/* global axios */

import ApiClient from './ApiClient';

class TaccCompanyAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  contextUrl(conversationId) {
    return `${this.url}/${conversationId}/tacc_company_context`;
  }

  getContext(conversationId) {
    return axios.get(this.contextUrl(conversationId), {
      headers: { 'Cache-Control': 'no-cache' },
    });
  }

  updateContext(conversationId, companyId) {
    return axios.patch(this.contextUrl(conversationId), {
      company_id: companyId,
    });
  }

  getBusinesses() {
    return axios.get(`${this.baseUrl()}/tacc_businesses`, {
      headers: { 'Cache-Control': 'no-cache' },
    });
  }
}

export default new TaccCompanyAPI();
